import {
  AiPortraitIcon,
  DatabaseIcon,
  InsightsIcon,
  SearchIcon,
} from '@medeloop/medeloop-components-library';
import aboutImage from 'src/assets/about.png';
import { AboutItem } from 'src/components';

export function AboutPage() {
  return (
    <section className="flex flex-col max-w-right-section mx-auto gap-20 pt-16 px-6 xl:px-0">
      <div className="flex items-center justify-center flex-wrap gap-5 w-full">
        <div className="flex flex-col gap-3 w-6/12">
          <h1 className="text-5xl font-semibold bg-gradient-to-r from-[#E6F4FB] via-[#BCF7FF] to-[#6D8EFF] text-transparent bg-clip-text">
            Empowering Data-Driven Healthcare
          </h1>
          <div className="text-[16px]">
            Medeloop Account is your organization's entry point to our research platform. From here,
            you can set up your team, manage access, and control how users engage with Medeloop's
            core tools: Studies, Grants, and Analytics.{' '}
          </div>
        </div>
        <img src={aboutImage} alt="about Medeloop" className="max-w-md w-full h-auto" />
      </div>
      <div className="flex justify-between flex-wrap gap-3 w-full">
        <AboutItem
          icon={<DatabaseIcon className="w-6 h-6 text-purple-300" />}
          title="Data"
          description="Automatically retrieves and structures high-quality, validated data from multiple sources using advanced matching techniques for seamless and reproducible analysis."
        />
        <AboutItem
          icon={<SearchIcon className="w-6 h-6 text-blue-600" />}
          title="Analysis"
          description="Standardized methods ensure validity, elevate statistical rigor, simplify complex analyses for non-experts, and enhance transparency through detailed documentation."
        />
        <AboutItem
          icon={<InsightsIcon className="w-6 h-6 text-yellow-300" />}
          title="Interpretation"
          description="Clear, visual summaries demystify complex statistics, simplify jargon for non-technical stakeholders, and highlight key limitations to guide responsible conclusions."
        />
        <AboutItem
          icon={<AiPortraitIcon className="w-6 h-6 text-purple-300" />}
          title="Follow-up Action"
          description="Fosters continuous improvement by enabling adaptive research that unites data-driven insights with domain expertise and builds on past feedback."
        />
      </div>
    </section>
  );
}
